/**
 * Task query keys.
 *
 * Every write, and every `task.*` frame from the socket, invalidates `all`. A
 * single change can move a task between lists — assign it to somebody else and
 * it leaves one person's "Assigned to me" and changes the counts on three tabs
 * — and only the server knows which lists are wrong afterwards.
 */
export const TASK_KEYS = {
  all: ['tasks'] as const,
  /** `params` is the list's own query string, so two lists never share an entry. */
  list: (params: Record<string, string | number>) => [...TASK_KEYS.all, 'list', params] as const,
  summary: () => [...TASK_KEYS.all, 'summary'] as const,
  detail: (taskId: string) => [...TASK_KEYS.all, 'detail', taskId] as const,
  activity: (taskId: string) => [...TASK_KEYS.all, 'activity', taskId] as const,
} as const;
